import { authorizeOauth2 } from "./oauth.js";
import { resolveDefaultOAuth2RedirectUri } from "./resolve-default-oauth2-redirect-url.js";
import { getEnvironmentVariables } from "@scalar/workspace-store/request-example";
//#region src/v2/blocks/scalar-auth-selector-block/helpers/run-oauth2-authorize.ts
/**
* Persists OAuth2 tokens split across the two schemes that care about them:
*
* - The **access token** lands on the consuming HTTP bearer scheme, so it is sent as
*   `Authorization: Bearer <token>` without the bearer scheme losing focus.
* - The **refresh token** stays on the oauth2 scheme, which is the only place that knows
*   how to refresh (token URL, flow, client credentials).
*/
var storeOAuth2Tokens = (eventBus, params) => {
	const { bearerSchemeName, oauth2Name, flowType, tokens } = params;
	eventBus.emit("auth:update:security-scheme-secrets", {
		payload: {
			type: "http",
			"x-scalar-secret-token": tokens.accessToken
		},
		name: bearerSchemeName
	});
	if (tokens.refreshToken) eventBus.emit("auth:update:security-scheme-secrets", {
		payload: {
			type: "oauth2",
			[flowType]: { "x-scalar-secret-refresh-token": tokens.refreshToken }
		},
		name: oauth2Name
	});
};
/**
* Runs the OAuth2 authorization flow and stores the resulting tokens on the bearer scheme
* (access token) and the oauth2 scheme (refresh token).
*
* Used by the bearer scheme's "Authorize via OAuth2" shortcut: it defaults the redirect URI
* (`authorizeOauth2` reads it straight off the flow), kicks off the flow, then routes the
* tokens through {@link storeOAuth2Tokens}.
*/
var runOAuth2Authorize = async (params) => {
	const { eventBus, bearerSchemeName, oauth2Name, flows, flowType, scopes, server, proxyUrl, environment, options } = params;
	const flow = flows[flowType];
	const result = await authorizeOauth2(flow && (flowType === "authorizationCode" || flowType === "implicit") ? {
		...flows,
		[flowType]: {
			...flow,
			"x-scalar-secret-redirect-uri": flow["x-scalar-secret-redirect-uri"] || resolveDefaultOAuth2RedirectUri(options ?? {}) || ""
		}
	} : flows, flowType, scopes, server, proxyUrl, getEnvironmentVariables(environment), options?.customFetch, options?.captureOAuth2Callback);
	const tokens = result[1];
	if (tokens?.accessToken) storeOAuth2Tokens(eventBus, {
		bearerSchemeName,
		oauth2Name,
		flowType,
		tokens
	});
	return result;
};
//#endregion
export { runOAuth2Authorize, storeOAuth2Tokens };

//# sourceMappingURL=run-oauth2-authorize.js.map